import src from "IMAGE";
export default { src, width: 1920, height: 1333, blurWidth: 8, blurHeight: 6, blurDataURL: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAAGCAYAAAD+Bd/7AAAAR0lEQVR42l2OWwpAIQgFD92ybu1/v2lMIH0MiuNLkrpTnI/cnAa/kAXRkxxwZEPWR0Z+ikasNA5qU4+0NBn3l3gur74xpucGZdMBHy3YR1gAAAAASUVORK5CYII="};
